/*global MOVE_DATA, localStorage*/
MOVE.DataStore = (function (MOVE) {
    "use strict";

    var getData = function (key) {
        return MOVE_DATA[key];
    };

    var setData = function (key, data) {
        MOVE_DATA[key] = data;
    };

    var clearData = function (key) {
        MOVE_DATA[key] = null;
    };

    MOVE.DataStore = {
        getData: getData,
        setData: setData,
        clearData: clearData
    };

    return MOVE.DataStore;

}(MOVE || {}));

MOVE.LocalStorage = (function (MOVE) {
    "use strict";

    var checkAvailability = function () {
      var test = 'test';
      try {
          localStorage.setItem(test, test);
          localStorage.removeItem(test);
          return true;
      } catch(e) {
          return false;
      }
    };

    var sizeSupported = function () {
     const size = Math.round(JSON.stringify(localStorage).length / (1024 * 1024));
     if ( size >= 5 ) {
      deleteLocalStorageOfRdcX();
      return false;
     }
     else 
      return true;
    };

    var deleteLocalStorageOfRdcX = function () {
      var item;
      const matchPattern = 'ccache-';
      for ( item in localStorage ) {
        if ( item.match(matchPattern) ) {
          localStorage.removeItem(item);
        }
      }
    };

    MOVE.LocalStorage = {
      isAvailable: checkAvailability() && sizeSupported()
    };

    return MOVE.LocalStorage;

}(MOVE || {}));

export const DataStore = MOVE.DataStore;
export const LocalStorage = MOVE.LocalStorage;



// WEBPACK FOOTER //
// ./shared_critical/store.js